export default "__VITE_ASSET__KQio6uPa__"